@if (!appNameIsDemo) {
  <app-share-menu [data]="dialogData || bottomSheetData" (dataChange)="dialogData || (bottomSheetData = $event)"></app-share-menu>
} @else {
  <ng-template #elseBlock>{{ 'Global.NotAvailableInDemo' | translate }}</ng-template>
}
